import React, { Component } from 'react';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Header, Form, Button, Message} from 'semantic-ui-react'
import * as Staff from '../../store/Staff';

class EditStaff extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        }
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    
    onChange(e, {name, value}){
        const {staff, actions} = this.props;
        actions.updateEditStaff({...staff, [name]:value});
    }

    async onSubmit(e) {
        const {staff, actions} = this.props;
        try {
            await actions.updateStaff(staff);
            actions.replace('/admin');
        } catch (error) {
            this.setState({error: error.message});
        }
    }
    render() {
        const {staff} = this.props;
        const {error} = this.state;
        return (
            <div className='staff'>
                <Header as='h1' content="Edit Staff" />
                {staff ? <Form onSubmit={this.onSubmit} error>
                <Message error content={error} />
                    <Form.Group widths='equal'>
                        <Form.Input name='firstName' label='First Name' value={staff.firstName} placeholder='First Name' onChange={this.onChange} />
                        <Form.Input name='lastName' label='Last Name' value={staff.lastName} placeholder='Last Name' onChange={this.onChange} />
                    </Form.Group>
                    <Form.Input name='title' label='Title' value={staff.title} placeholder='Title' onChange={this.onChange} />
                    <Form.Input name='email' label='Email' value={staff.email} placeholder='Email' onChange={this.onChange} />
                    <Form.Input name='phone' label='Phone' value={staff.phone} placeholder='Phone' onChange={this.onChange} />
                    <Button primary content='Save' />
                </Form> : staff}
            </div>
        );
    }
}

EditStaff.propTypes = {

};

const mapStateToProps = (state, ownProps) => {
    return {
        staff: Staff.selector(state).staff[ownProps.match.params.staffId],
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Staff.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditStaff));